export const colors = {
	//'Application, AP-Fin-spons': 'rgb(255,102,102,0.4)',
	'Key Conference Dates': 'rgb(255,159,26,0.4)',
	'GC : Documents and Meetings' : 'rgb(242,214,0,0.4)',
	'GC: Actions/decisions needed' : 'rgb(242,214,0,0.4)',
	'Finance: sponsors': 'rgb(0,194,224,0.4)',
	'Finance: Registration' : 'rgb(0,194,224,0.4)',
	'Finance: budget and travel grants' : 'rgb(0,194,224,0.4)',
	'Publicity/website: Website and Event Technology' : 'rgb(255,120,203,0.4)',
	'Publicity/Website Publicity': 'rgb(255,120,203,0.4)',
	'Technical Program: Special Sessions': 'rgb(112,181,0,0.4)',
	'Technical Program: Competitions': 'rgb(112,181,0,0.4)',
	'Technical Program: Tutorials': 'rgb(112,181,0,0.4)',
	'Technical Program: COI': 'rgb(112,181,0,0.4)',
	'Technical Program: Submissions and Review': 'rgb(112,181,0,0.4)',
	'Technical Program: Plenary/Keynotes/Panels/Industry events': 'rgb(112,181,0,0.4)',
	'Technical Program: program': 'rgb(112,181,0,0.4)',
	'Proceedings: Camera copy': 'rgb(81,232,152,0.4)',
	'Proceedings:': 'rgb(81,232,152,0.4)',
	//'Article/Review process': 'rgb(51,255,255,0.4)',
	'local arrangements: Venue': 'rgb(195,119,224,0.4)',
	'local arrangements: Social+CIS Events': 'rgb(195,119,224,0.4)',
	//'local arrangements: Venue': 'rgb(195,119,224,0.4)',
	//'Technical Program': 'rgb(51,153,255,0.4)',
	//'Venue/Registration': 'rgb(153,51,255,0.4)',
	//'Proceedings': 'rgb(255,51,255,0.4)',
	//'Social': 'rgb(255,51,153,0.4)',
	//'test': 'rgb(255,51,153,0.4)',
}    

export const BASE_URL = 'https://api.trello.com/1/'
export const appKey = 'f8da03ef4e7b8f8ed708470a3680fab2'
export const appName = 'IEEECOTOOL'
export const appSecret = '0e20fdbd87c3680d589d65baac10f3d0119bcfbaf0edd9d36c1762886c26dbb7'
